module.exports = __webpack_public_path__ + "img/il.874270d6.svg";